import { MarketAPI } from "../api";
import { Area } from "./Area.class";

export class Market {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  static async getMarketArea(payload) {
    const { data } = await MarketAPI.getMarketArea(payload);
    let markets = new Market(data.result);
    markets.areas = markets.areas.map(item=>new Area(item))
    return markets;
  }
  static async getMarketsSummaryInfo(payload) {
    const { data } = await MarketAPI.getMarketsSummaryInfo(payload);
    // Array Return
    // data.result.map((item) => new Market(item));
    // Object Return
    data.result = new Market(data.result)
    return data.result;
  }
  static async getMarketsOccupancyRateInfo(ids, date) {
    const { data } = await MarketAPI.getMarketsOccupancyRateInfo(ids, date);
    return data.result;
  }
  static async getMarket(id) {
    const { data } = await MarketAPI.getMarket(id);
    data.result = new Market(data.result);
    return data.result;
  }
  static async updateMarket(payload) {
    const { data } = await MarketAPI.updateMarket(payload);
    data.result = new Market(data.result);
    return data.result;
  }
  static async getMarketByProject(projectId) {
    const { data } = await MarketAPI.getMarketByProject(projectId);
    return data.result.map(item => new Market(item));
  }
  static async updateImageBase64(payload) {
    const { data } = await MarketAPI.updateImageBase64(payload);
    return data.result;
  }
}
